import { render, staticRenderFns } from "./filter-posts-by-content.vue?vue&type=template&id=bfd9e176"
import script from "./filter-posts-by-content.vue?vue&type=script&lang=js"
export * from "./filter-posts-by-content.vue?vue&type=script&lang=js"
import style0 from "./filter-posts-by-content.vue?vue&type=style&index=0&id=bfd9e176&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./filter-posts-by-content.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports